import type { ColorSchemeId } from "@stackje/common/colorScheme";
import { createContext } from "react";

export const ColorSchemeContext = createContext<{
  colorSchemeId: ColorSchemeId;
  setColorSchemeId: (colorSchemeId: ColorSchemeId) => void;
  customColors: string[] | null;
  setCustomColors: (colors: string[] | null) => void;
}>({
  colorSchemeId: "natural",
  setColorSchemeId: () => {},
  customColors: null,
  setCustomColors: () => {},
});
